import { render } from "./DeductionType.vue?vue&type=template&id=5af0ca7e"
import script from "./DeductionType.vue?vue&type=script&lang=js"
export * from "./DeductionType.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DeductionType.vue?vue&type=style&index=0&id=5af0ca7e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__